const initBlock = async function( $block ) {
	const { Swiper } = await import( 'swiper' );
	const { Navigation, Grid } = await import( 'swiper/modules' );
	await import( 'swiper/css/bundle' );

	const $sidebarPosts = $block.find( '.sidebar-posts' );
	if ( !$sidebarPosts.length ) { return false; }
	const $slider = $sidebarPosts.find( '.sidebar-posts__slider-main' );
	const $buttonNext = $sidebarPosts.find( '.slider-nav__next' );
	const $buttonPrev = $sidebarPosts.find( '.slider-nav__prev' );

	const swiperPostsParams = {
		modules: [Navigation, Grid],
		navigation: {
			nextEl: $buttonNext[0],
			prevEl: $buttonPrev[0]
		},
		speed: 500,
		init: false,
		loop: false,
		allowTouchMove: false,
		spaceBetween: 20,
		slidesPerView: 1,
		slidesPerGroup: 1,
		grid: {
			rows: 1,
			fill: 'column',
		},
		breakpoints: {
			1024: {
				spaceBetween: 32,
				grid: {
					rows: 3,
					fill: 'column',
				},
			},
			1599: {
				spaceBetween: 36,
				grid: {
					rows: 3,
					fill: 'column',
				},
			},
			1792: {
				spaceBetween: 40,
				grid: {
					rows: 3,
					fill: 'column',
				},
			}
		}
	};
	const swiperPosts = new Swiper( $slider[0], swiperPostsParams );
	swiperPosts.init();
};

app.loadBlock( initBlock, 'section-article-content', '.section-article-content' );

if ( module.hot ) {
	module.hot.accept();
}
